<div *appRole="['Movimientos.Ver']" class="dialog-container">
  <ngx-spinner [zIndex]=100 name="spMovimiento" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
    type="ball-atom" [fullScreen]="false">
  </ngx-spinner>

  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
  <h1 mat-dialog-title>Ver <strong>movimiento</strong></h1>
  <mat-divider></mat-divider>
  <br>
  <div mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true">

    <!-- INFORMACIÓN DEL MOVIMIENTO -->
    <mat-card class="mb-3 p-3">
      <h3>Movimiento</h3>
      <div class="row">
        <div class="col-lg-3"><strong>Tipo:</strong> {{movimientoDetailDto.tipoMovimiento != undefined || null ? movimientoDetailDto.tipoMovimiento.descripcion : '' }}</div>
        <div class="col-lg-3"><strong>Origen relacionado:</strong> {{ movimientoDetailDto.origenMovimiento || '-' }}
        </div>
        <div class="col-lg-3"><strong>Importe:</strong> {{ movimientoDetailDto.importe != null ?
          (movimientoDetailDto.importe | currency) : '-' }}</div>
        <div class="col-lg-3" *ngIf="movimientoDetailDto.anulado"><strong>Estado:</strong> Anulado</div>
      </div>

      <div class="row mt-2">
        <div class="col-lg-3"><strong>Fecha Emisión:</strong> {{ movimientoDetailDto.fechaEmision ?
          (movimientoDetailDto.fechaEmision | date:'dd/MM/yyyy') : '-' }}</div>
        <div class="col-lg-3"><strong>Fecha Pago:</strong> {{ movimientoDetailDto.fechaPago ?
          (movimientoDetailDto.fechaPago | date:'dd/MM/yyyy') : '-' }}</div>
        <div class="col-lg-3"><strong>Fecha Vencimiento:</strong> {{ movimientoDetailDto.fechaVencimiento ?
          (movimientoDetailDto.fechaVencimiento | date:'dd/MM/yyyy') : '-' }}</div>
        <div class="col-lg-3"><strong>Fecha Modificación:</strong> {{ movimientoDetailDto.fechaModificacion ?
          (movimientoDetailDto.fechaModificacion | date:'dd/MM/yyyy') : '-' }}</div>
      </div>
    </mat-card>

    <!-- PERIODO Y CONTRATO -->
    <mat-card class="mb-3 p-3">
      <h3>Periodo y Contrato</h3>
      <div class="row">
        <div class="col-lg-3"><strong>Mes / Año:</strong> {{ movimientoDetailDto.periodoMes || '-' }}/{{
          movimientoDetailDto.periodoAnio || '-' }}</div>
        <div class="col-lg-3"><strong>Periodo Contrato:</strong>
          <div *ngIf="movimientoDetailDto.periodoContrato">
            {{ movimientoDetailDto.periodoContrato?.periodoMes || '-' }} // {{
            movimientoDetailDto.periodoContrato?.periodoAnio || '-' }} {{
            movimientoDetailDto.periodoContrato?.importeAlquiler || '-' }}
          </div>
        </div>
        <div class="col-lg-3"><strong>Contrato:</strong> {{ movimientoDetailDto.contrato?.descripcion || '-' }}</div>
      </div>
    </mat-card>

    <!-- PERSONAS -->
    <mat-card class="mb-3 p-3">
      <h3>Personas y Propiedad</h3>
      <div class="row">
        <div class="col-lg-3"><strong>Propietario:</strong> {{ movimientoDetailDto.propietario?.descripcion || '-' }}
        </div>
        <div class="col-lg-3"><strong>Inquilino:</strong> {{ movimientoDetailDto.inquilino?.descripcion || '-' }}</div>
        <div class="col-lg-3"><strong>Propiedad:</strong> {{ movimientoDetailDto.propiedad?.descripcion || '-' }}</div>
      </div>
    </mat-card>

    <!-- BONIFICACIONES -->
    <mat-card class="mb-3 p-3" *ngIf="movimientoDetailDto.bonificacion">
      <h3>Bonificación</h3>
      <div class="row">
        <div class="col-lg-4"><strong>Descripción:</strong> {{
          movimientoDetailDto.bonificacion?.tipoBonificacion?.descripcion || '-' }}</div>
      </div>
    </mat-card>

    <mat-divider></mat-divider>
  </div>
</div>
